import { render, staticRenderFns } from "./MyColleague.vue?vue&type=template&id=537ebe9f&"
import script from "./MyColleague.vue?vue&type=script&lang=js&"
export * from "./MyColleague.vue?vue&type=script&lang=js&"
import style0 from "./MyColleague.vue?vue&type=style&index=0&id=537ebe9f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports